import { Heading, Text } from '@ui';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import type { ReleaseNote } from './releaseNotes';

/** Notes grouped by version; shared by the "Neu in swarm" dialog and the about page. */
export function ReleaseNotesList({
  notes,
  onNavigate,
}: {
  notes: ReleaseNote[];
  onNavigate?: () => void;
}) {
  const { t } = useTranslation();
  return (
    <div style={{ display: 'grid', gap: 'var(--space-4)' }}>
      {notes.map((note) => (
        <section
          key={note.version}
          aria-label={t('releaseNotes.version', { version: note.version })}
          style={{ display: 'grid', gap: 'var(--space-2)' }}
        >
          <Heading level={3} size="sm">
            {t('releaseNotes.version', { version: note.version })}
          </Heading>
          <ul
            style={{
              margin: 0,
              paddingLeft: 'var(--space-5)',
              display: 'grid',
              gap: 'var(--space-2)',
            }}
          >
            {note.items.map((item) => (
              <li key={item.text}>
                <Text as="span">{item.text}</Text>
                {item.to && (
                  <>
                    {' '}
                    <Link to={item.to} onClick={onNavigate}>
                      {t('releaseNotes.view')}
                    </Link>
                  </>
                )}
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}
